import styles from './id.module.css';
import CommonLayout from '../commonLayout/commonLayout';
import DOMPurify from 'dompurify';
const Id = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text13']),
        }}
      ></h1>
      <CommonLayout
        textSize="big"
        text={DOMPurify.sanitize(textData['text14'])}
        videoSrc={
          'https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-video-lipstick.mp4'
        }
        poster="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-video-lipstick-cover.jpg"
        direction="reverse"
        videoPlayEffect={true}
        loop={true}
        playsInline={true}
        muted={true}
        preload={true}
      />
      <CommonLayout
        textSize="big"
        text={DOMPurify.sanitize(textData['text15'])}
        videoSrc={
          'https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-video-open.mp4'
        }
        poster="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-video-open-cover.jpg"
        videoPlayEffect={true}
        loop={true}
        playsInline={true}
        muted={true}
        preload={true}
      />
    </div>
  );
};

export default Id;
